import { RouteContext } from "@opendash/router";
import { makeAutoObservable, runInAction } from "mobx";
import Parse from "parse";
import { Agency, Route } from "../js/parsegenerated";

export class HomePageState {
  ctx: RouteContext;

  routes: Route[] = [];
  loading: boolean = false;
  createModalVisible: boolean = false;

  constructor(ctx: RouteContext) {
    this.ctx = ctx;

    ctx.setTitle("gtfs:home.title");
    ctx.setDescription("Export der Daten im GTFS-Format");

    makeAutoObservable(this);
  }

  setCreateModalVisible(value: boolean) {
    this.createModalVisible = value;
  }

  async fetchRoutes(agency: Agency) {
    runInAction(() => {
      this.routes = [];
      this.loading = true;
    });

    const routes = await new Parse.Query(Route)
      .equalTo("agency_id", agency)
      .findAll();

    routes.sort((a, b) => {
      const orderA = a.get("route_sort_order") ?? Infinity;
      const orderB = b.get("route_sort_order") ?? Infinity;
      return orderA - orderB;
    });

    runInAction(() => {
      this.routes = routes;
      this.loading = false;
    });
  }
}
